import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonApiService } from '../../../common-api.service';
import { SpeakerService } from '../../../speaker.service';
import { SnackbarService } from '../../../snackbar.service';
import {
  MonthOption,
  buildMonthOptions,
  findMonthByMonthYear,
  findMonthOption,
} from '../../../util/month-options.util';

@Component({
  selector: 'app-product-usage-summary',
  templateUrl: './product-usage-summary.component.html',
  styleUrls: ['./product-usage-summary.component.css']
})
export class ProductUsageSummaryComponent implements OnInit, OnDestroy {
  public reportData: any[] = [];

  public monthOptions: MonthOption[] = [];
  public selectedMonthValue: string;

  displayColumns = [
    'product_name',
    'category_name',
    'total_units',
    'cases_count',
  ];
  displayHeaders = [
    'Product',
    'Category',
    'Total Units',
    'Cases Completed',
  ];

  constructor(
    public speaker: SpeakerService,
    private api: CommonApiService,
    private snackbar: SnackbarService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.speaker.listData = [];
    this.monthOptions = buildMonthOptions();

    const qp = this.route.snapshot.queryParamMap;
    const qMonth = Number(qp.get('month'));
    const qYear = Number(qp.get('year'));
    const found = qMonth && qYear ? findMonthByMonthYear(this.monthOptions, qMonth, qYear) : undefined;
    this.selectedMonthValue = (found || this.monthOptions[0]).value;

    this.generateReport();
  }

  ngOnDestroy(): void {
    this.speaker.exportBackend = null;
  }

  get selectedMonthLabel(): string {
    return findMonthOption(this.monthOptions, this.selectedMonthValue)?.label || '';
  }

  generateReport(): void {
    const selected = findMonthOption(this.monthOptions, this.selectedMonthValue);
    if (!selected) {
      return;
    }

    const payload = {
      month: selected.month,
      year: selected.year,
    };

    this.speaker.listData = [];
    this.speaker.isLoading = true;
    this.api.callRoute('product', '/usage_summary', payload).subscribe({
      next: (res: any[]) => {
        this.speaker.isLoading = false;
        this.reportData = res || [];
        this.speaker.listData = this.reportData;
        this.speaker.model = 'product';
        this.speaker.displayColumns = this.displayColumns;
        this.speaker.displayHeaders = this.displayHeaders;
        this.speaker.exportBackend = {
          model: 'product',
          route: '/usage_summary/export',
          payload: { month: selected.month, year: selected.year },
          filename: `Product Usage - ${this.selectedMonthLabel}.xlsx`,
        };

        if (this.reportData.length === 0) {
          this.snackbar.info('No records found for the selected month');
        }
      },
      error: () => {
        this.speaker.isLoading = false;
        this.snackbar.error('Failed to load report');
      }
    });
  }
}
